import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

const WhiteIcon = ({ icon }) => {
  const classes = useStyles();
  return <FontAwesomeIcon icon={icon} className={classes.icon} />;
};

export default WhiteIcon;
